exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * Master z-index list\n *\n * Due to the inherent global nature of z-index, all z-indexes used should be defined and\n * referenced as variables from this file.\n */\n.reposition-target {\n  background-color: #f4bf42;\n  height: 10px;\n  width: 100%;\n  margin-bottom: 8px;\n  z-index: 999;\n  opacity: 0; }\n\n.reposition-target-active {\n  opacity: 1; }\n", ""]);

// exports
